// extracted by mini-css-extract-plugin
export default {"image":"zfgjHQ","wideMT":"SqazN0","wideMB":"xnvXBK"};